import 'css-chunk:src/app/containers/GuestHome/Programs/GroupContentReviewPage/ContentDetails/components/Gallery/Gallery.scss';export default {
  "Gallery": "_Gallery_198wg_1",
  "description": "_description_198wg_1",
  "UserTitle": "_UserTitle_198wg_6"
};